import React from 'react'
import Center from './Center'
import useForm from '../hooks/useForm.js'
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { createApiEndpoint } from '../index.js'
import { MuiMaterials } from '../@index.js';
import * as global from '../data/global';
import { isSite3dPinned } from '../data/global';
import { useAuth } from "../provider/authProvider";
import { Spinner } from './windowChrome/index.js';
import video1 from "../assets/videos/video1.mp4";
import * as Assets from "../assets/@index";

const getFreshModel = () => ({
    email: "",
});

const EmailLogin = () => {
    const { setToken, clearToken } = useAuth();
    const navigate = useNavigate();
    const [loading, setLoading] = React.useState(false);
    const [currentTheme, setCurrentTheme] = React.useState(global.gw.theme || 'dark');
    const [forceUpdate, setForceUpdate] = React.useState(0);

    document.title = "Login";

    // Helper function to get theme-aware colors
    const getThemeColor = React.useCallback((lightColor, darkColor) => {
        if (global.gw.theme === 'light') {
            return lightColor;
        }
        return darkColor;
    }, []);

    // Listen for theme changes
    React.useEffect(() => {
        const handleThemeChange = () => {
            setCurrentTheme(global.gw.theme || 'dark');
            setForceUpdate(prev => prev + 1);
        };
        window.addEventListener('themeChanged', handleThemeChange);
        return () => window.removeEventListener('themeChanged', handleThemeChange);
    }, []);

    // Also listen for the global theme change event
    React.useEffect(() => {
        if (global.gw.themeChanged) {
            setCurrentTheme(global.gw.theme || 'dark');
            setForceUpdate(prev => prev + 1);
        }
    }, [global.gw.themeChanged]);

    // Poll for theme changes (fallback)
    React.useEffect(() => {
        const interval = setInterval(() => {
            const currentThemeValue = global.gw.theme || 'dark';
            if (currentThemeValue !== currentTheme) {
                setCurrentTheme(currentThemeValue);
                setForceUpdate(prev => prev + 1);
            }
        }, 100);
        return () => clearInterval(interval);
    }, [currentTheme]);

    const {
        values,
        errors,
        setErrors,
        handleInputChange
    } = useForm(getFreshModel);

    const login = async (e) => {
        setLoading(true);
        e.preventDefault();

        if (validate()) {
            if (global.gw.bypass) {
                global.gw.token = "test token";
                global.gw.auth = "test token";
                global.gw.email = values.email.toLowerCase().trimEnd();
                //navigate("/sites", { replace: true });
            }
            else {
                let userExists = await createApiEndpoint(global.Endpoints.GrainWave)
                    .fetchUser(values.email);
                if (userExists) {
                    let windowSize = window.document.getElementsByClassName("windowSize")[0];
                    if (windowSize) {
                        global.gw.windowSize = windowSize.getBoundingClientRect();
                        //alert(`height: ${global.gw.windowSize.height}\ntop: ${global.gw.windowSize.top}\nbottom: ${global.gw.windowSize.bottom}`);
                    }
                    //navigate("/");
                }
            }
        }

        if (validate()) {
            let userExists = await createApiEndpoint(global.Endpoints.GrainWave)
                .fetchLogin(values.wall);

            if (userExists) {
                let splits = userExists.split("|");
                if (splits.length !== 2)
                    navigate("/sites");

                // Avoid showing the previous account's sites until fetchUserSites completes.
                global.gw.siteInfos = [];

                global.gw.token = splits[0];
                global.gw.auth = splits[1] ?? null;
                global.gw.email = values.email.toLowerCase().trimEnd();
                setToken(splits[0]);
                navigate(isSite3dPinned() ? "/site3d" : "/sites", { replace: true });
            }
            else {
                if (global.gw.bypass) {
                    global.gw.token = "test token";
                    global.gw.auth = "test token";
                    global.gw.email = values.email.toLowerCase().trimEnd();
                    setToken("test token");
                    navigate(isSite3dPinned() ? "/site3d" : "/sites", { replace: true });
                }
                else {
                    clearToken();
                    navigate("/sites", { replace: true });
                }
            }
        }
        setLoading(false);
    };

    const validate = () => {
        let temp = {
            email: "",
            wall: null,
        };
        temp.email = (/\S+@\S+\.\S+/).test(values.email) ? "" : "Email is not valid.";
        temp.wall = values.wall && values.wall !== "" ? "" : "This field is required.";
        setErrors(temp);
        return Object.values(temp).every(x => x === "");
    };

    const theme = React.useMemo(() => {
        const isLight = global.gw.theme === 'light';
        return MuiMaterials.createTheme({
            components: {
                MuiInputLabel: {
                    styleOverrides: {
                        root: {
                            color: isLight ? '#000000' : '#f4cc8e',
                            borderColor: isLight ? '#666666' : 'rgb(244, 204, 142)',
                            ...(isLight && {
                                '&:not(.MuiInputLabel-shrink)': {
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    left: '14px',
                                },
                            }),
                        },
                        shrink: {
                            top: isLight ? '8px' : undefined,
                        },
                    }
                },
                MuiButton: {
                    styleOverrides: {
                        root: {
                            fontSize: "18px",
                            background: isLight ? '#e0e0e0' : '#2d2d2d',
                            color: isLight ? '#333333' : 'rgb(244, 204, 142)',
                        }
                    }
                },
                MuiIconButton: {
                    styleOverrides: {
                        sizeMedium: {
                            color: isLight ? '#333333' : 'rgb(244, 204, 142)'
                        }
                    }
                },
                MuiOutlinedInput: {
                    styleOverrides: {
                        root: {
                            color: isLight ? '#333333' : '#f4cc8e',
                            "& .MuiOutlinedInput-notchedOutline": {
                                border: `0.5px solid ${isLight ? '#cccccc' : '#f4cc8e4d'}`,
                            },
                            "&.Mui-focused": {
                                "& .MuiOutlinedInput-notchedOutline": {
                                    border: `0.5px solid ${isLight ? '#666666' : '#f4cc8e'}`,
                                },
                            },
                            "&:hover": {
                                "& .MuiOutlinedInput-notchedOutline": {
                                    border: `0.5px solid ${isLight ? '#666666' : '#f4cc8e'}`,
                                },
                            },
                        }
                    }
                },
                MuiTextField: {
                    styleOverrides: {
                        root: {
                            ".MuiInputLabel-root.Mui-focused": {
                                color: isLight ? '#000000' : '#f4cc8e',
                            },
                        },
                    }
                },
                MuiFormControl: {
                    styleOverrides: {
                        root: {
                            border: `0.5px solid ${isLight ? '#cccccc' : '#f4cc8e4d'}`,
                            ".MuiInputLabel-root.Mui-focused": {
                                color: isLight ? '#000000' : '#f4cc8e',
                            },
                            ".MuiSvgIcon-root": {
                                color: isLight ? '#333333' : '#f4cc8e',
                            },
                        },
                    }
                },
                MuiMenuItem: {
                    styleOverrides: {
                        root: {
                            color: isLight ? '#333333' : '#f4cc8e',
                        },
                    }
                },
            },
        });
    }, [currentTheme, forceUpdate]);

    return (
        <MuiMaterials.Box
            sx={{
                display: "flex",
                position: "fixed",
                top: "0px",
                left: "0px",
                bottom: "0px",
                right: "0px",
                flexDirection: "row",
                alignItems: "stretch",
                overflowX: "auto",
                paddingBottom: "0px",
                height: "100vh",
                width: "100%",
            }}
        >
            <video className="video1"
                autoPlay loop muted
                style={{
                    position: "absolute",
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                }}
            >
                <source src={video1} type='video/mp4' />
            </video>
            <MuiMaterials.ThemeProvider theme={theme} key={`login-theme-${currentTheme}-${forceUpdate}`}>
                <MuiMaterials.Card
                    sx={{
                        boxShadow: 0,
                        bgcolor: getThemeColor('#ffffff', '#2d2d2d'),
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: "-webkit-fill-available",
                        height: "-webkit-fill-available",
                        width: "100%",
                    }}
                    className={"windowSize"}
                >
                    <form noValidate onSubmit={login}
                        style={{
                            width: "200px",
                            display: 'flex',         // Make the form a flex container
                            flexDirection: 'column', // Stack children vertically
                            alignItems: 'stretch', 
                        }}
                    >
                        <MuiMaterials.TextField
                            key={`login-email-${currentTheme}-${forceUpdate}`}
                            autoComplete="on"
                            fullWidth
                            label="Email"
                            name="email"
                            variant="outlined"
                            InputProps={{
                                style: {
                                    fontSize: "18px",
                                    background: getThemeColor('#ffffff', '#2d2d2d'),
                                    color: getThemeColor('#333333', '#f4cc8e'),
                                }
                            }}
                            sx={{
                                margin: "5px auto",
                                background: getThemeColor('#ffffff', '#2d2d2d'),
                                color: getThemeColor('#333333', '#f4cc8e'),
                                '& .MuiInputLabel-root': {
                                    color: getThemeColor('#000000', '#f4cc8e'),
                                    top: getThemeColor('8px', '0'),
                                },
                                '& .MuiInputLabel-root.Mui-focused': {
                                    color: getThemeColor('#000000', '#f4cc8e'),
                                    top: getThemeColor('8px', '0'),
                                },
                                '& .MuiOutlinedInput-root': {
                                    '& fieldset': {
                                        borderColor: getThemeColor('#cccccc', '#f4cc8e'),
                                    },
                                    '&:hover fieldset': {
                                        borderColor: getThemeColor('#666666', '#f4cc8e'),
                                    },
                                    '&.Mui-focused fieldset': {
                                        borderColor: getThemeColor('#666666', '#f4cc8e'),
                                    },
                                    // Autofill styling
                                    '& input:-webkit-autofill': {
                                        WebkitBoxShadow: `0 0 0 1000px ${getThemeColor('#ffffff', '#2d2d2d')} inset`,
                                        WebkitTextFillColor: getThemeColor('#333333', '#f4cc8e'),
                                        caretColor: getThemeColor('#333333', '#f4cc8e'),
                                    },
                                    '& input:-webkit-autofill:hover': {
                                        WebkitBoxShadow: `0 0 0 1000px ${getThemeColor('#ffffff', '#2d2d2d')} inset`,
                                        WebkitTextFillColor: getThemeColor('#333333', '#f4cc8e'),
                                    },
                                    '& input:-webkit-autofill:focus': {
                                        WebkitBoxShadow: `0 0 0 1000px ${getThemeColor('#ffffff', '#2d2d2d')} inset`,
                                        WebkitTextFillColor: getThemeColor('#333333', '#f4cc8e'),
                                    },
                                    '& input:-webkit-autofill:active': {
                                        WebkitBoxShadow: `0 0 0 1000px ${getThemeColor('#ffffff', '#2d2d2d')} inset`,
                                        WebkitTextFillColor: getThemeColor('#333333', '#f4cc8e'),
                                    },
                                },
                            }}
                            onChange={handleInputChange}
                            {...(errors.email && { error: true, helperText: errors.email })}
                        />
                        <MuiMaterials.TextField
                            key={`login-password-${currentTheme}-${forceUpdate}`}
                            autoComplete="on"
                            fullWidth
                            className="nextField"
                            label="Password"
                            name="wall"
                            type="password"
                            variant="outlined"
                            InputProps={{
                                style: {
                                    fontSize: "18px",
                                    background: getThemeColor('#ffffff', '#2d2d2d'),
                                    color: getThemeColor('#333333', '#f4cc8e'),
                                }
                            }}
                            sx={{
                                margin: "5px auto",
                                background: getThemeColor('#ffffff', '#2d2d2d'),
                                color: getThemeColor('#333333', '#f4cc8e'),
                                '& .MuiInputLabel-root': {
                                    color: getThemeColor('#000000', '#f4cc8e'),
                                    top: getThemeColor('8px', '0'),
                                },
                                '& .MuiInputLabel-root.Mui-focused': {
                                    color: getThemeColor('#000000', '#f4cc8e'),
                                    top: getThemeColor('8px', '0'),
                                },
                                '& .MuiOutlinedInput-root': {
                                    '& fieldset': {
                                        borderColor: getThemeColor('#cccccc', '#f4cc8e'),
                                    },
                                    '&:hover fieldset': {
                                        borderColor: getThemeColor('#666666', '#f4cc8e'),
                                    },
                                    '&.Mui-focused fieldset': {
                                        borderColor: getThemeColor('#666666', '#f4cc8e'),
                                    },
                                    // Autofill styling
                                    '& input:-webkit-autofill': {
                                        WebkitBoxShadow: `0 0 0 1000px ${getThemeColor('#ffffff', '#2d2d2d')} inset`,
                                        WebkitTextFillColor: getThemeColor('#333333', '#f4cc8e'),
                                        caretColor: getThemeColor('#333333', '#f4cc8e'),
                                    },
                                    '& input:-webkit-autofill:hover': {
                                        WebkitBoxShadow: `0 0 0 1000px ${getThemeColor('#ffffff', '#2d2d2d')} inset`,
                                        WebkitTextFillColor: getThemeColor('#333333', '#f4cc8e'),
                                    },
                                    '& input:-webkit-autofill:focus': {
                                        WebkitBoxShadow: `0 0 0 1000px ${getThemeColor('#ffffff', '#2d2d2d')} inset`,
                                        WebkitTextFillColor: getThemeColor('#333333', '#f4cc8e'),
                                    },
                                    '& input:-webkit-autofill:active': {
                                        WebkitBoxShadow: `0 0 0 1000px ${getThemeColor('#ffffff', '#2d2d2d')} inset`,
                                        WebkitTextFillColor: getThemeColor('#333333', '#f4cc8e'),
                                    },
                                },
                            }}
                            onChange={handleInputChange}
                            {...(errors.wall && { error: true, helperText: errors.wall })}
                        />
                        <MuiMaterials.LoadingButton
                            key={`login-button-${currentTheme}-${forceUpdate}`}
                            fullWidth
                            type="submit"
                            loading={loading}
                            loadingIndicator={<Spinner size="inline" />}
                            variant="outlined"
                            size="small"
                            sx={{
                                position: "sticky",
                                fontSize: "18px",
                                height: "55px",
                                borderColor: getThemeColor('#cccccc', '#f4cc8e'),
                                borderStyle: "solid",
                                background: getThemeColor('#e0e0e0', '#2d2d2d'),
                                color: getThemeColor('#333333', '#f4cc8e'),
                                textTransform: "capitalize",
                                width: "100%",
                                margin: "5px auto",
                                ':hover': {
                                    bgcolor: getThemeColor('#d0d0d0', '#0d0d0d'),
                                },
                                '& .MuiCircularProgress-root': {
                                    color: getThemeColor('#333333', '#f4cc8e'),
                                },
                                '& .MuiLoadingButton-loadingIndicator': {
                                    pointerEvents: 'none',
                                },
                            }}
                        >
                            Login
                        </MuiMaterials.LoadingButton>
                    </form>
                </MuiMaterials.Card>
            </MuiMaterials.ThemeProvider>
        </MuiMaterials.Box>
    );
}

export default EmailLogin;


//{/*value={values.email}*/ }
//value={values.name}